import { ActivityPosition, POSITION_TOP } from 'global/constants';
import { canShowOptionLetter } from '../multiple-choice.utils';
import { MultipleChoiceOption } from '../multiple-choice.constants';
import { MultipleChoiceLetter } from '../multiple-choice';
import MultipleChoiceImage from '../image/multiple-choice-image';
import { MultipleChoiceButtonText } from '../multiple-choice-view.style';
import * as Styled from './multiple-choice-text-image-view.style';

type Props = {
  optionMinHeight: number | null;
  imagePosition: ActivityPosition | null;
  showOptionLetter: boolean | null;
  option: MultipleChoiceOption;
  index: number;
};

const MultpleChoiceTextImageView = ({
  optionMinHeight,
  imagePosition,
  showOptionLetter,
  option,
  index,
}: Props) => {
  return (
    <Styled.MultipleChoiceImageText
      $minHeight={optionMinHeight || 80}
      $imagePosition={imagePosition}
    >
      {imagePosition === POSITION_TOP && (
        <Styled.MultipleChoiceImageTextInner>
          <MultipleChoiceImage option={option} />
        </Styled.MultipleChoiceImageTextInner>
      )}

      <Styled.MultipleChoiceImageTextColumn>
        {canShowOptionLetter(showOptionLetter) && (
          <MultipleChoiceLetter index={index} />
        )}
        <MultipleChoiceButtonText>{option.text}</MultipleChoiceButtonText>
      </Styled.MultipleChoiceImageTextColumn>

      {imagePosition !== POSITION_TOP && (
        <Styled.MultipleChoiceImageTextInner>
          <MultipleChoiceImage option={option} />
        </Styled.MultipleChoiceImageTextInner>
      )}
    </Styled.MultipleChoiceImageText>
  );
};

export default MultpleChoiceTextImageView;
